(function () {
  'use strict';

  var WISHLIST_KEY = 'suave_wishlist_v1';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('suave:wishlist-updated', { detail: { items: items } }));
    } catch (e) {
      /* ignore */
    }
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function t(key, fallback) {
    var strings = window.__SUAVE_WISHLIST__ || {};
    return strings[key] || fallback;
  }

  function renderWishlist(root) {
    if (!root) return;
    var listEl = root.querySelector('[data-wishlist-items]');
    var emptyEl = root.querySelector('[data-wishlist-empty]');
    var countEl = root.querySelector('[data-wishlist-count]');
    if (!listEl) return;

    var items = readWishlist();
    if (countEl) countEl.textContent = String(items.length);

    if (!items.length) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    listEl.innerHTML = items
      .map(function (item, index) {
        var title = escapeHtml(item.title || 'Saved product');
        var url = escapeHtml(item.url || '#');
        var image = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="320" height="320">'
          : '<div class="suave-wishlist__placeholder" aria-hidden="true"></div>';
        return (
          '<article class="suave-wishlist__item" data-wishlist-index="' +
          index +
          '">' +
          '<a href="' +
          url +
          '" class="suave-wishlist__image-link">' +
          image +
          '</a>' +
          '<div class="suave-wishlist__body">' +
          '<a href="' +
          url +
          '" class="suave-wishlist__title">' +
          title +
          '</a>' +
          '<div class="suave-wishlist__actions">' +
          '<a href="' +
          url +
          '" class="suave-wishlist__view">' +
          escapeHtml(t('viewProduct', 'View product')) +
          '</a>' +
          '<button type="button" class="suave-wishlist__remove" data-remove-index="' +
          index +
          '">' +
          escapeHtml(t('remove', 'Remove')) +
          '</button>' +
          '</div>' +
          '</div>' +
          '</article>'
        );
      })
      .join('');
  }

  function bindWishlistPage() {
    var root = document.querySelector('[data-suave-wishlist-page]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    renderWishlist(root);

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove-index]');
      if (!btn) return;
      var index = parseInt(btn.getAttribute('data-remove-index'), 10);
      var items = readWishlist();
      if (isNaN(index) || index < 0 || index >= items.length) return;
      items.splice(index, 1);
      writeWishlist(items);
      renderWishlist(root);
    });

    document.addEventListener('suave:wishlist-updated', function () {
      renderWishlist(root);
    });
  }

  function updateWishlistCountBadges() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  window.SuaveWishlist = {
    key: WISHLIST_KEY,
    read: readWishlist,
    write: writeWishlist,
    updateCountBadges: updateWishlistCountBadges
  };

  function init() {
    bindWishlistPage();
    updateWishlistCountBadges();
    document.addEventListener('suave:wishlist-updated', updateWishlistCountBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
